import React from "react";
import { Mail, Instagram, MapPin, Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <h3 className="navigation-logo">Ka Lā 'Alohi</h3>
              <p className="body-regular footer-tagline">
                Luxury Hawaiian skincare crafted with island traditions and modern excellence
              </p>
            </div>

            <div className="footer-contact">
              <h4 className="heading-3">Connect With Us</h4>
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-icon">
                    <Mail size={24} />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Email</span>
                    <a href="mailto:veronica.gella@yahoo.com" className="contact-value">
                      veronica.gella@yahoo.com
                    </a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <Globe size={24} />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Website</span>
                    <a href="https://www.alohiskinandwellness.com/" target="_blank" rel="noopener noreferrer" className="contact-value">
                      www.alohiskinandwellness.com
                    </a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <MapPin size={24} />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Location</span>
                    <span className="contact-value">Hawaiian Islands</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-social">
              <h4 className="heading-3">Follow Our Journey</h4>
              <div className="social-content">
                <p className="body-small">
                  Scan to follow us on Instagram for daily skincare inspiration and island beauty tips
                </p>
                <div className="instagram-qr">
                  <img 
                    src="/images/instagram-qr.png" 
                    alt="Instagram QR code — scan to follow @alohiskinandwellness"
                    className="qr-code"
                  />
                  <div className="qr-label">
                    <Instagram size={16} />
                    <span className="body-small">@alohiskinandwellness</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-service-areas" data-testid="footer-service-areas">
              <span className="footer-service-areas-label">Proudly serving Hawaiʻi</span>
              <p className="footer-service-areas-text">
                Handcrafted in Waiʻanae, Oʻahu · Serving Honolulu, Kapolei, Ko Olina, Makaha, Ewa Beach, Pearl City, Mililani, Kailua, and all of Leeward and West Oʻahu · Shipping to Maui, Hawaiʻi Island (Big Island), Kauaʻi, Molokaʻi, Lanaʻi, and the mainland United States.
              </p>
            </div>
            <div className="footer-links">
              <button className="footer-link">Privacy Policy</button>
              <button className="footer-link">Terms of Service</button>
              <button className="footer-link">Shipping Info</button>
              <button className="footer-link">Returns</button>
            </div>
            <div className="footer-copyright">
              <p className="body-small">
                © 2025 Ka Lā 'Alohi. Handcrafted with aloha in Hawaii.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;